/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext, useEffect } from "react"
import { Fieldset } from "primereact/fieldset"
import PropTypes from "prop-types"
import { Toast } from "primereact/toast"
import { Toolbar } from "primereact/toolbar"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"
import CustomToolBar from "../../../ToolBar/customToolbar"
import {
  dischargeStatusTypes,
  dischargeReasonStatusTypes,
  confirmation,
  testStrips,
  covidVaccinated,
} from "../../../types/dropDownTypes"
import { errorMessages } from "../../../types/messages"
import {
  existsErrors,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  formatMixedQuestions,
  filterAdditionalQuestions,
  checkDisplayConditional,
  checkConditionalRender,
  prevForm,
  nextForm,
} from "../../../utils/utils"
import { InputText } from "primereact/inputtext"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { INTERVIEW_SECTIONS } from "../../../types/interviewTypes"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"
import { UserContext } from "../../../../../context/userContext"

const Discharge = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interview,
    handleLoadPrev,
    handleLoadNext,
    handleSectionsCompleted,
    sectionsCompleted,
    questions,
    updateInterviewValues,
    additionalQuestions,
    sections,
    activeIndex,
    administrativeInterview,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [discharge, setDischarge] = useState(
    interview[INTERVIEW_SECTIONS.DISCHARGE]
  )
  const [validationErrors, setValidationErrors] = useState({})
  const [mixedQuestions, setMixedQuestions] = useState([])

  const toast = useRef(null)

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions.filter(
          (q) =>
            q.section === INTERVIEW_SECTIONS.DISCHARGE &&
            !q.field.endsWith("section")
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.DISCHARGE
        )
      }
      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  const saveData = (setNextForm, previousForm, setNavigationItem) => {
    updateInterviewValues(INTERVIEW_SECTIONS.DISCHARGE, discharge)
    if (previousForm) {
      if (interview[INTERVIEW_SECTIONS.RECORD_MGMT].gpra_interview_conducted) {
        handleLoadPrev(true)
      }
      setNextForm(prevForm(sections, activeIndex, administrativeInterview))
      setNavigationItem()
    } else {
      if (validForm()) {
        handleLoadNext(true)
        handleSubmitPut(endpoints.SAVE_DISCHARGE_DATA, {
          GpraJ1: discharge?.gpra_j_1,
          GpraJ2: discharge?.gpra_j_2,
          GpraJ2a: discharge?.gpra_j_2a,
          GpraJ3: discharge?.gpra_j_3,
          GpraJ4: discharge?.gpra_j_4,
          GpraJ5: discharge?.gpra_j_5,
          GpraJ6: discharge?.gpra_j_6,
          GpraInterviewId:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          GpraJId: discharge?.gpra_j_id,
          Additional: getAdditionalQuestions(discharge),
          EditMode: editMode,
          EditedBy: userCtx.session?.user?.staff_id,
        })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              updateInterviewValues(INTERVIEW_SECTIONS.DISCHARGE, {
                ...discharge,
                gpra_j_id: response.data.gpraJId,
              })
              handleLoadNext(false)
              setNextForm(
                nextForm(sections, activeIndex, administrativeInterview)
              )
              setNavigationItem()
              handleSectionsCompleted({
                ...sectionsCompleted,
                ...{ discharge: true },
              })
            }
          })
          .catch(() => {
            handleLoadNext(false)
            showMessage(false, errorMessages.genericError, toast)
          })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const validForm = () => {
    const errors = {}
    if (!discharge?.gpra_j_1 && showQuestion(questions, "gpra_j_1")) {
      errors.gpra_j_1 = errorMessages.requiredMessage
    }
    if (!discharge?.gpra_j_2 && showQuestion(questions, "gpra_j_2")) {
      errors.gpra_j_2 = errorMessages.requiredMessage
    } else if (
      discharge?.gpra_j_2 === 2 &&
      showQuestion(questions, "gpra_j_2")
    ) {
      if (!discharge?.gpra_j_2a && showQuestion(questions, "gpra_j_2")) {
        errors.gpra_j_2a = errorMessages.requiredMessage
      } else if (
        discharge?.gpra_j_2a === 13 &&
        showQuestion(questions, "gpra_j_2")
      ) {
        if (!discharge?.gpra_j_2a1 && showQuestion(questions, "gpra_j_2")) {
          errors.gpra_j_2a1 = errorMessages.requiredMessage
        }
      }
    }
    if (
      discharge?.gpra_j_3 === undefined &&
      showQuestion(questions, "gpra_j_3")
    ) {
      errors.gpra_j_3 = errorMessages.requiredMessage
    } else if (
      discharge?.gpra_j_3 === false &&
      showQuestion(questions, "gpra_j_3")
    ) {
      if (
        discharge?.gpra_j_4 === undefined &&
        showQuestion(questions, "gpra_j_4")
      ) {
        errors.gpra_j_4 = errorMessages.requiredMessage
      }
    }
    if (!discharge?.gpra_j_5 && showQuestion(questions, "gpra_j_5")) {
      errors.gpra_j_5 = errorMessages.requiredMessage
    }
    if (!discharge?.gpra_j_6 && showQuestion(questions, "gpra_j_6")) {
      errors.gpra_j_6 = errorMessages.requiredMessage
    }

    setValidationErrors(
      validateQuestions(
        discharge,
        INTERVIEW_SECTIONS.DISCHARGE,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  const renderDefaultMain = (question) => {
    if (question.field === "gpra_j_1") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. On what date was the client discharged?`}
            required
          />
          <Calendar
            className={
              validationErrors.gpra_j_1
                ? gpraStyles.calendarError
                : gpraStyles.calendar
            }
            showIcon
            showButtonBar
            value={discharge?.gpra_j_1}
            onChange={(e) => {
              updateState(
                "gpra_j_1",
                e.value,
                null,
                null,
                discharge,
                setDischarge,
                null
              )
              removeError("gpra_j_1")
            }}
            disabled={disabled}
          />
          <FormError error={validationErrors.gpra_j_1} />
        </div>
      )
    }
    if (question.field === "gpra_j_2") {
      return (
        <>
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. What is the client’s discharge status?`}
              required
            />
            <Dropdown
              className={
                validationErrors.gpra_j_2
                  ? gpraStyles.input4Error
                  : gpraStyles.input4
              }
              value={discharge?.gpra_j_2}
              onChange={(e) => {
                removeError("gpra_j_2")
                removeError("gpra_j_2a")
                removeError("gpra_j_2a1")
                if (e.value !== 2) {
                  updateState(
                    "gpra_j_2",
                    e.value,
                    null,
                    null,
                    discharge,
                    setDischarge,
                    [
                      { key: "gpra_j_2a", value: 0 },
                      { key: "gpra_j_2a1", value: "" },
                    ]
                  )
                } else {
                  updateState(
                    "gpra_j_2",
                    e.value,
                    null,
                    null,
                    discharge,
                    setDischarge,
                    null
                  )
                }
              }}
              options={dischargeStatusTypes}
              optionLabel="label"
              optionValue="value"
              disabled={disabled}
              showClear={discharge?.gpra_j_2}
            />
            <FormError error={validationErrors.gpra_j_2} errorType={2} />
          </div>
          {discharge?.gpra_j_2 === 2 && (
            <div className={gpraStyles.formRow}>
              <FormLabel
                label={
                  "If the client was terminated, what was the reason for termination?"
                }
                left={"1"}
              />
              <Dropdown
                className={
                  validationErrors.gpra_j_2a
                    ? gpraStyles.input6Error
                    : gpraStyles.input6
                }
                value={discharge?.gpra_j_2a}
                onChange={(e) => {
                  removeError("gpra_j_2a")
                  removeError("gpra_j_2a1")
                  if (e.value !== 13) {
                    updateState(
                      "gpra_j_2a",
                      e.value,
                      null,
                      null,
                      discharge,
                      setDischarge,
                      [{ key: "gpra_j_2a1", value: "" }]
                    )
                  } else {
                    updateState(
                      "gpra_j_2a",
                      e.value,
                      null,
                      null,
                      discharge,
                      setDischarge,
                      null
                    )
                  }
                }}
                options={dischargeReasonStatusTypes}
                optionLabel="label"
                optionValue="value"
                disabled={discharge?.gpra_j_2 !== 2 || disabled}
                showClear={discharge?.gpra_j_2a}
              />
              <FormError error={validationErrors.gpra_j_2a} errorType={2} />
            </div>
          )}
          {discharge?.gpra_j_2 === 2 && discharge?.gpra_j_2a === 13 && (
            <div className={gpraStyles.formRow}>
              <FormLabel label={"Other (Specify)"} />
              <InputText
                className={
                  validationErrors.gpra_j_2a1
                    ? gpraStyles.inputText6Error
                    : gpraStyles.inputText6
                }
                placeholder={
                  discharge?.gpra_j_2a !== 13 ? "Not Applicable" : ""
                }
                value={discharge?.gpra_j_2a1}
                onChange={(e) => {
                  updateState(
                    "gpra_j_2a1",
                    e.target.value,
                    null,
                    null,
                    discharge,
                    setDischarge,
                    null
                  )
                  removeError("gpra_j_2a1")
                }}
                disabled={discharge?.gpra_j_2a !== 13 || disabled}
              />
              <FormError error={validationErrors.gpra_j_2a1} errorType={2} />
            </div>
          )}
        </>
      )
    }
    if (question.field === "gpra_j_3") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}.Did the program test this client for HIV?`}
            required
          />
          <Dropdown
            className={
              validationErrors.gpra_j_3
                ? gpraStyles.input3Error
                : gpraStyles.input3
            }
            value={discharge?.gpra_j_3}
            onChange={(e) => {
              updateState(
                "gpra_j_3",
                e.value,
                null,
                null,
                discharge,
                setDischarge,
                null
              )
              removeError("gpra_j_3")
            }}
            options={confirmation}
            optionLabel="label"
            optionValue="value"
            disabled={disabled}
            showClear={discharge?.gpra_j_3 !== undefined}
          />
          <FormError error={validationErrors.gpra_j_3} errorType={2} />
        </div>
      )
    }
    if (question.field === "gpra_j_4") {
      if (discharge?.gpra_j_3 === false) {
        return (
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Did the program refer this client for HIV testing with another provider?`}
              required
            />
            <Dropdown
              className={
                validationErrors.gpra_j_4
                  ? gpraStyles.input3Error
                  : gpraStyles.input3
              }
              value={discharge?.gpra_j_4}
              onChange={(e) => {
                updateState(
                  "gpra_j_4",
                  e.value,
                  null,
                  null,
                  discharge,
                  setDischarge,
                  null
                )
                removeError("gpra_j_4")
              }}
              options={confirmation}
              optionLabel="label"
              optionValue="value"
              disabled={discharge?.gpra_j_3 !== false || disabled}
              showClear={discharge?.gpra_j_4 !== undefined}
            />
            <FormError error={validationErrors.gpra_j_4} errorType={2} />
          </div>
        )
      }
    }
    if (question.field === "gpra_j_5") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. Did the program provide Naloxone and/or Fentanyl Test Strips to this client at any time during their involvement in grant funded services?`}
            required
          />
          <Dropdown
            className={
              validationErrors.gpra_j_5
                ? gpraStyles.input5Error
                : gpraStyles.input5
            }
            value={discharge?.gpra_j_5}
            onChange={(e) => {
              updateState(
                "gpra_j_5",
                e.value,
                null,
                null,
                discharge,
                setDischarge,
                null
              )
              removeError("gpra_j_5")
            }}
            options={testStrips}
            optionLabel="label"
            optionValue="value"
            disabled={disabled}
            showClear={discharge?.gpra_j_5}
          />
          <FormError error={validationErrors.gpra_j_5} errorType={2} />
        </div>
      )
    }
    if (question.field === "gpra_j_6") {
      return (
        <div className={gpraStyles.formRow}>
          <FormLabel
            label={`${question.number}. Is the client fully vaccinated against the virus that causes COVID-19?`}
            required
          />
          <Dropdown
            className={
              validationErrors.gpra_j_6
                ? gpraStyles.input6Error
                : gpraStyles.input6
            }
            value={discharge?.gpra_j_6}
            onChange={(e) => {
              updateState(
                "gpra_j_6",
                e.value,
                null,
                null,
                discharge,
                setDischarge,
                null
              )
              removeError("gpra_j_6")
            }}
            options={covidVaccinated}
            optionLabel="label"
            optionValue="value"
            disabled={disabled}
            showClear={discharge?.gpra_j_6}
          />
          <FormError error={validationErrors.gpra_j_6} errorType={2} />
        </div>
      )
    }
  }

  return (
    <>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              prevForm={true}
              saveData={saveData}
              nextForm={true}
              toast={toast}
            />
          }
        ></Toolbar>
      )}
      <Fieldset legend="J. DISCHARGE STATUS" style={{ marginBottom: "1rem" }}>
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={discharge}
                    setEntity={setDischarge}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.DISCHARGE}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, discharge)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={discharge}
                      setEntity={setDischarge}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.DISCHARGE}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
    </>
  )
}

Discharge.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}

Discharge.defaultProps = {
  showToolBar: true,
  disabled: false,
}

export default Discharge
